import { API, getToken } from "./api";

// POST /api/chat and dispatch each SSE event to onEvent(name, data).
export async function streamChat(body, onEvent) {
  const token = getToken();
  const resp = await fetch(`${API}/chat`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json", ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify(body),
  });
  if (!resp.ok || !resp.body) throw new Error((await resp.text()) || "Stream failed");
  const reader = resp.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const events = buffer.split("\n\n");
    buffer = events.pop() || "";
    for (const ev of events) {
      let eventName = "message", dataStr = "";
      for (const ln of ev.split("\n")) {
        if (ln.startsWith("event:")) eventName = ln.slice(6).trim();
        else if (ln.startsWith("data:")) dataStr += ln.slice(5).trim();
      }
      if (!dataStr) continue;
      try { onEvent(eventName, JSON.parse(dataStr)); }
      catch (e) { console.warn("[sse] event parse failed:", e?.message || e); }
    }
  }
}
